export const PERMISSIONS = {
    PROJECT_VIEW: "project.view",
    PROJECT_MANAGE: "project.manage",
    PROJECT_CREATE: "project.create",
    PIPELINE_MANAGE: "pipeline.manage",
    CALENDAR_VIEW: "calendar.view",
    CALENDAR_EDIT: "calendar.edit",
    CONTACTS_MANAGE: "contacts.manage",
    LEADS_MANAGE: "leads.manage",
    ESTIMATE_CREATE: "estimate.create",
    CONTRACT_CREATE: "contract.create",
    PRODUCTION_PROCESS: "production.process",
    INSTALL_SCHEDULE: "install.schedule",
    INSTALL_COMPLETE_SUBMIT: "install.complete.submit",
    PHOTOS_ADD: "photos.add",
    USERS_MANAGE: "users.manage",
    TASK_INITIAL_INSPECTION: "task.initial.inspection",
    TASK_INITIAL_ESTIMATE: "task.initial.estimate",
    TASK_INITIAL_CONTRACT_SIGNING: "task.initial.contract-signing",
    TASK_INITIAL_MATERIAL_ORDERING: "task.initial.material-ordering",
    TASK_INITIAL_JOB_EXECUTION: "task.initial.job-execution",
    TASK_INITIAL_FINAL_SETTLEMENT: "task.initial.final-settlement",
    ADMIN_SETTINGS: "admin.settings",
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const ROLES = {
    ADMIN_OWNER: "Admin/Owner",
    PRODUCTION: "Production",
    SALES: "Sales",
    INSTALL: "Install",
    SUPER_ADMIN: "Super Admin",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const PERMISSIONS_BY_ROLE: Record<Role, Set<Permission>> = {
    [ROLES.SUPER_ADMIN]: new Set(Object.values(PERMISSIONS)),
    [ROLES.ADMIN_OWNER]: new Set(Object.values(PERMISSIONS)),
    [ROLES.PRODUCTION]: new Set<Permission>([
        PERMISSIONS.PROJECT_VIEW,
        PERMISSIONS.PIPELINE_MANAGE,
        PERMISSIONS.PRODUCTION_PROCESS,
        PERMISSIONS.CALENDAR_VIEW,
        PERMISSIONS.CALENDAR_EDIT,
        PERMISSIONS.INSTALL_SCHEDULE,
        PERMISSIONS.TASK_INITIAL_MATERIAL_ORDERING,
        PERMISSIONS.TASK_INITIAL_JOB_EXECUTION,
        PERMISSIONS.TASK_INITIAL_FINAL_SETTLEMENT,
    ]),
    [ROLES.SALES]: new Set<Permission>([
        PERMISSIONS.CALENDAR_VIEW,
        PERMISSIONS.CALENDAR_EDIT,
        PERMISSIONS.CONTACTS_MANAGE,
        PERMISSIONS.LEADS_MANAGE,
        PERMISSIONS.ESTIMATE_CREATE,
        PERMISSIONS.CONTRACT_CREATE,
        PERMISSIONS.PROJECT_CREATE,
        PERMISSIONS.PROJECT_MANAGE,
        PERMISSIONS.PROJECT_VIEW,
        PERMISSIONS.PRODUCTION_PROCESS,
        PERMISSIONS.TASK_INITIAL_INSPECTION,
        PERMISSIONS.TASK_INITIAL_ESTIMATE,
        PERMISSIONS.TASK_INITIAL_CONTRACT_SIGNING,
    ]),
    [ROLES.INSTALL]: new Set<Permission>([
        PERMISSIONS.CALENDAR_VIEW,
        PERMISSIONS.PHOTOS_ADD,
        PERMISSIONS.TASK_INITIAL_INSPECTION,
        PERMISSIONS.TASK_INITIAL_MATERIAL_ORDERING,
        PERMISSIONS.TASK_INITIAL_JOB_EXECUTION,
        PERMISSIONS.TASK_INITIAL_FINAL_SETTLEMENT,
    ]),
};

export const DEFAULT_ROLE: Role = ROLES.SALES;
